import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { OOOrderType } from "src/app/shared/models/oo-order-type";

@Component({
	selector: "app-order-type-settings",
	templateUrl: "./order-type-settings.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class OrderTypeSettingsComponent implements OnInit {
	@Input() orderType: OOOrderType;
	@Output() orderTypeChange = new EventEmitter<OOOrderType>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	checkoutReceiptOptions: GenericLabelValue[] = [
		{
			label: "None",
			value: 0,
		},
		{
			label: "Button",
			value: 1,
		},
		{
			label: "QR Code",
			value: 2,
		},
	];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {}

	async verifySavedOt() {
		if (!this.orderType.key) {
			const savedOt = await this.venueSvc.ooOrderTypeSave(this.orderType);
			this.orderType = this.venueSvc.ooOrderTypes.find((ot) => ot.key === savedOt.key);
		}
	}
}
